angular.module('TetherApp').factory('keywordService', [
    '$http',
    function($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let indexKeyword = function () {
            let uri = '/api/v1/keyword/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let create = function (keyword) {
            let uri = '/api/v1/keyword';
            return $http.post(
                uri,
                keyword,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteKeyword = function (keywordId) {
            let uri = '/api/v1/keyword/' + keywordId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getKeywordByKeywordAndShortcode = function (keyword, shortcodeId, key, keywordId) {

            let uri = '/api/v1/keyword/find-by-keyword-and-shortcode-id/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.post(
                uri,
                {
                    keyword: keyword,
                    shortcode_id : shortcodeId,
                    key : key,
                    keyword_id : keywordId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let update = function (keyword) {
            let uri = '/api/v1/keyword/' + keyword.id;
            return $http.put(
                uri,
                keyword,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            create: create,
            deleteKeyword: deleteKeyword,
            getKeywordByKeywordAndShortcode: getKeywordByKeywordAndShortcode,
            indexKeyword: indexKeyword,
            update: update
        }
    }
]);
